<template>
  <ChartWrapper class="ranking-chart" :status="status">
    <div class="bar-chart">
      <svg class="root" ref="root" />

      <div class="months-numbers-chart grid" v-show="barsData2">
        <transition-group tag="div" name="fade" >
          <div class="month-item" :class="'w-'+i" v-for="(item, i) in barsData" :key="'evol_month_'+i" :style="{left: monthIndexPos(i) + 'px', width: monthBlockWidth + 'px'}">
            <div class="cell cell-main">
              <div class="number blue">{{item.value.toFixed(2)}}%</div>
            </div>
            <div class="cell cell-compare" v-if="barsData2">
              <div class="number red">{{barsData2[i].value.toFixed(2)}}%</div>
            </div>
          </div>
        </transition-group>
      </div>
    </div>
  </ChartWrapper>
</template>

<script>

import d3 from '@/utils/d3_importer'
import moment from 'moment';
import ChartWrapper from '@/components/IndicatorCards/parts/charts/ChartWrapper'
import Vue from 'vue'

let formatDate = (d)=>{
  let mnt = moment(d)
  let m = mnt.format('MMM').replace('.','')
  m = m.charAt(0).toUpperCase() + m.slice(1)
  let y = mnt.format('YY')
  return m+' '+y
}
export default {
  name: "SectorBarChart",
  props: ['status','data','compareData'],
  components:{
    ChartWrapper
  },
  data (){
    return {
      xScale: d3.scaleBand().padding(0.2),
      yScale: d3.scaleLinear(),
      xSubScale: d3.scaleBand().padding(0.2),
      margin: {left: 20, top: 20, right: 15, bottom: 50},
      monthBlockWidth: 0
    }
  },
  mounted () {
    if(this.data) this.drawChart()
  },
  computed: {
    barsData(){
      return this.data && this.data.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
    },
    barsData2(){
      return this.compareData && this.compareData.data[0].data.map((d)=>({value: d.data?d.data[0].value:0,valueDate: d.valueDate}))
    }
  },
  methods: {
    drawChart(){
      if(!this.barsData) return
      let barsData = this.barsData
      let barsData2 = this.barsData2
      let height = this.$refs.root.clientHeight
      let width = this.$refs.root.clientWidth
      let margin= this.margin
      let contentWidth = width - margin.left - margin.right
      let contentHeight = height - margin.top - margin.bottom

      this.xScale
        // .domain(d3.extent(barsData,(d)=>d.valueDate))
        .domain(barsData.map((d)=>new Date(d.valueDate)))
        .range([0, contentWidth])
      this.yScale
        // .domain(d3.extent(barsData,(d)=>d.value))
        .domain([0,Math.max(100,d3.max((barsData2?[...barsData,...barsData2]:barsData),(d)=>d.value))*1.1])
        .range([contentHeight, 0])
      
      if(barsData2){
        this.xSubScale
          .domain([0,1])
          .range([-this.xScale.bandwidth()/2,this.xScale.bandwidth()/2]) //BASURA!
      } else {
        this.xSubScale
          .domain([0,0])
          .range([0,0])
      }
      
      let barWidth = barsData2?this.xSubScale.bandwidth():this.xScale.bandwidth()*0.65
      let labelOffset = barsData2?-barWidth/2 : 0

      let svg = d3.select(this.$refs.root)
      let xAxis = svg.selectAll('.x-axis').data([null])
      xAxis = xAxis.merge(xAxis.enter().append('g').attr('class','x-axis')).call(d3.axisBottom(this.xScale))
        .attr('transform',`translate(${margin.left},${height-margin.bottom})`)
      xAxis.select('.domain').style('display','none')
      xAxis.selectAll('.tick').each(function(d){
        let str = formatDate(d)
        let m = str.split(' ')[0]
        let y = str.split(' ')[1]
        let txt = d3.select(this).select('text').text(null).attr('transform',`translate(${labelOffset},0)`)
        d3.select(this).select('line').style('display','none')
        txt.append("tspan").attr("x", 0).attr("y", 10).text(m);
        txt.append("tspan").attr("x", 0).attr("y", 10).attr("dy", 1.7 + "em").text(y);
        // .attr("dy", ++lineNumber * lineHeight + dy + "em")
      })
      // let yAxis = svg.selectAll('.y-axis').data([null])
      // yAxis.merge(yAxis.enter().append('g').attr('class','y-axis')).call(d3.axisLeft(this.yScale)).attr('transform',`translate(${margin.left},0)`)
      
    
      
      
      let content = svg.selectAll('.content').data([null])
      content = content.merge(content.enter().append('g').attr('class','content'))
      content.attr('transform',`translate(${margin.left},${margin.top})`)
      
      let groups = content.selectAll('.group').data(barsData)
      let groupsEnter = groups.enter().append('g').attr('class','group')
      groups = groups.merge(groupsEnter)
      
      let bars = groups.selectAll('.bar').data((d,i)=>barsData2?[barsData[i],barsData2[i]]:[barsData[i]])
      let barsEnter = bars.enter().append('g').attr('class','bar')
      barsEnter.append('rect').attr('class','back-rect')
      barsEnter.append('rect').attr('class',(d,i)=>'front-rect'+(i===0?'':' compared'))
      barsEnter.append('text').attr('class','value')
      
      bars.exit().remove()

      bars = bars.merge(barsEnter)
      
      bars.attr('transform',(d)=>`translate(${this.xScale(new Date(d.valueDate))+this.xScale.bandwidth()/2},0)`)
      bars.select('.back-rect')
        .attr('x',(d,i)=>this.xSubScale(i)-barWidth/2)
        .attr('width',barWidth)
        .attr('height',contentHeight)
      bars.select('.front-rect').transition()
        .attr('x',(d,i)=>this.xSubScale(i)-barWidth/2)
        .attr('width',barWidth)
        .attr('height',(d)=>this.yScale(0)-this.yScale(d.value))
        .attr('y',(d)=>this.yScale(d.value))
      bars.select('text')
        .attr('x',(d,i)=>this.xSubScale(i))
        .attr('y',(d)=>this.yScale(d.value))
        .text((d)=>d.value?(Math.round(d.value)+'%'):'')
        .attr('dy','-.4em')
        .classed('flipped',(d)=>d.value>this.yScale.domain()[1])
        .style('display',barsData2?'none':'block')
        
      let refLine = svg.selectAll('.ref-line').data([null])
      let refLineEnter = refLine.enter().append('g').attr('class','ref-line')
      refLineEnter.append('line')
      refLineEnter.append('text').text('100%').attr('dx',0).attr('dy',-5)
      refLine = refLine.merge(refLineEnter)
      refLine.attr('transform',`translate(0,${this.yScale(100)+margin.top})`)
      refLine.select('line').attr('x1',0).attr('x2',contentWidth)

      this.monthBlockWidth = contentWidth / this.barsData.length
    },
    monthIndexPos (index) {
      return (index * this.monthBlockWidth) + this.margin.left/2
    },
  },
  watch: {
    data () {
      this.drawChart()
    },
    compareData () {
      Vue.nextTick().then(() => this.drawChart())
    }
  }
}
</script>

<style lang="stylus" scoped>
.ranking-chart
  .bar-chart
    width: 100%
    height: vh(320px)
    display: flex;
    flex-direction: column;
    
    .root
      //flex 1 1 auto
    svg
      width 100%
      height 100%
      //flex 1 1 auto
      font-family: Lato
      >>> .bar
        .back-rect
          fill #eee
        .front-rect 
          fill $bs-blue
          &.compared
            fill $compare-color
        .value
          margin-left 4px
          font-family: 'Lato'
          m-font-size(8,10)
          font-weight bold
          dominant-baseline: text-after-edge;
          text-anchor: middle;
          fill: #222
          &.flipped
            dominant-baseline: text-before-edge;
            fill: #fff;
          .desktop &
            m-font-size(10,12)

      >>> .ref-line
        line
          stroke: #666;
          stroke-width: 0.5px;
          shape-rendering: crispedges;
        text
          font-size 12px
  .months-numbers-chart
    position: relative
    height: vh(110px)
    flex: 1 1 auto
    margin-top: 10px;
    width: 100%
    .month-item
      position absolute
      top: 0px
      height: 100%
      border-left: 1px solid black
      text-align: center
      display: flex
      flex-direction: column
      justify-content: center;
      font-family: Georgia
      m-font-size(15,17)
      // .cell
      //   border solid 1px #ddd
      &:first-child
        border none
      &.fade-enter-active
        transition opacity .3s

      &.fade-leave-active
        transition opacity .1s
        transition-delay 0s

      &.fade-enter, &.fade-leave-to
        opacity 0
      .cell
        height 50px
        display flex
        align-items center
        justify-content center
        &.cell-main
          border-bottom 1px solid black
      .number
        m-font-size(11, 13)
        margin-bottom: vh(5px)
        &.blue
          color: $bs-blue
        &.red
          color: $compare-color
        
</style>